import { CustomerLight } from "src/app/backend/models/customer/customer";
import { VatNatureType } from "./vat-nature-type";

export enum CartItemType {
  MEDICAL_SERVICE = "medical-service",
  DRUG_ASSIGNMENT = "drug-assignment",
  PARAPHARMACEUTICAL = "parapharmaceutical",
  PRODUCT_SALE = "product-sale",
  ADVANCE_PAYMENT = "advance-payment"
}

export interface Cart {
  id: string;
  bookId: string;
  patientId: string;
  items: CartItem[];
  rateableTotal: number;
  vatTaxAmount: number;
  taxesAmount: number;
  taxedTotal: number;
  discountedTotal: number;
  adjustedTotal: number;
  itemsTotal: number;
  discount: number;
  adjustment: number;
  vatSummaryDetails: VatSummary[];
}

export enum CartItemUnit {
  PIECE = "piece",
  PACKAGE = "package"
}

export interface CartItem {
  id: string;
  number: string;
  name: string;
  description?: string;
  quantity: number;
  unitPrice: number;
  unit?: CartItemUnit;
  discount: number;
  vat: number;
  vatNature?: VatNatureType;

  rateable: number; // Imponibile di riga (al netto della cassa)
  vatTaxAmount: number; // Ammontare della tassa IVA
  taxedTotal: number; // Totale tassato (senza il contributo cassa)
  adjustment?: number; // Aggiustamento sul totale
  adjustedTotal: number; // Totale corretto (Totale da pagare)

  createdBy: {
    id: string;
    name: string;
  };
  createdAt: Date; // da usare per trovare item specifico (toIsoString)

  updatedAt?: Date;

  rateTableItemId: string; // id del rateTableItem
  bookItemId?: string;
  type: CartItemType;

  rateTable?: {
    id: string;
    name: string;
  };

  ticket?: {
    id: string;
    number: string;
    customer?: CustomerLight;
  };

  quote?: {
    id: string;
    number: string;
  };

  executedBy: Array<{ id: string; name: string; percentage: number }>;
  executedAt: string;
}

export interface CreateCartItem {
  number: string;
  name: string;
  description?: string;
  quantity: number;
  unitPrice: number;
  unit?: CartItemUnit;
  discount: number;
  vat: number;
  vatNature?: VatNatureType;

  rateable: number; // Imponibile di riga (al netto della cassa)
  vatTaxAmount: number; // Ammontare della tassa IVA
  taxedTotal: number; // Totale tassato (senza il contributo cassa)
  adjustment?: number; // Aggiustamento sul totale
  adjustedTotal: number; // Totale corretto (Totale da pagare)

  updatedAt?: Date;

  rateTableItemId: string; // id del rateTableItem

  type: CartItemType;

  rateTable?: {
    id: string;
    name: string;
  };

  ticket?: {
    id: string;
    number: string;
  };

  physiciansPercentage: number;
  executedBy: Array<{ id: string; name: string; percentage: number }>;
  executedAt: string;
}

export interface VatSummary {
  tax: number;
  detail: VatDetail;
}

export interface VatDetail {
  rateable: number;
  taxAmount: number;
  vatNatureList?: VatNatureType[];
}
